<template>
    <div class="home">
        <div class="tree-container">
            <template v-if="familyTree!=null">
                <div class="tree" :style="widthStyle" v-if="view=='2d'">
                    <family-node :direction="direction" :type="type" :node="familyTree" @toolMenu="toolMenu"
                                 @toolMenuS="toolMenuS"
                                 :style="{pointerEvents:isPress?'none':'unset'}"/>
                </div>
                <div class="relation" ref="graphContainer" v-else>

                </div>
            </template>
            <template v-else>
                <div class="controls">
                    <el-button @click="addNode('root')" type="primary" icon="el-icon-plus">添加节点</el-button>
                </div>
            </template>
        </div>
        <el-dialog
                :title="'对'+currentNode.name+'操作'"
                :visible.sync="showToolMenu"
                v-if="currentNode!=null"
                :close-on-click-modal="false"
        >
            <div class="here">
                <div class="dos">
                    <div class="parents">
                        <div @click="addNode('parent')" class="po male"
                             :class="{disabled:editWhich===true||currentNode.parent!=''}">
                            <i class="el-icon-user-solid"></i>
                            <span>添加父辈</span>
                        </div>
                    </div>
                    <div class="siblings">
                        <div class="lan">
                            <div @click="moveLeft" class="po male"
                                 :class="{disabled:editWhich===true||currentNode.parent==''||firstPo}">
                                <i class="el-icon-arrow-left"></i>
                                <span>向左移位</span>
                            </div>
                            <div @click="addNode('siblings')" class="po male"
                                 :class="{disabled:editWhich===true||currentNode.parent==''}">
                                <i class="el-icon-user-solid"></i>
                                <span>添加兄妹</span>
                            </div>
                        </div>
                        <div @click="editNode('me')" class="my"
                             :class="{ 'male': currentNode.gender === 'male', 'female': currentNode.gender === 'female' }">
                            <i class="tx" v-if="currentNode.photo"><img :src="currentNode.photo"></i>
                            <i class="el-icon-user-solid" v-else></i>
                            <span>{{ currentNode.name }}</span>
                        </div>
                        <div class="lan">
                            <div @click="moveRight" class="po male"
                                 :class="{disabled:editWhich===true||currentNode.parent==''||lastPo}">
                                <i class="el-icon-arrow-right"></i>
                                <span>向右移位</span>
                            </div>
                            <div @click="addNode('spouse')" class="po"
                                 :class="{disabled:editWhich===true, 'female': currentNode.gender === 'male', 'male': currentNode.gender === 'female' }">
                                <i class="el-icon-user-solid"></i>
                                <span>添加配偶</span>
                            </div>
                        </div>
                    </div>
                    <div class="children">
                        <div class="po male" @click="addNode('children')">
                            <i class="el-icon-user-solid"></i>
                            <span>添加子辈</span>
                        </div>
                    </div>
                </div>
                <el-popconfirm title="确定要删除这个节点吗？" @confirm="deleteNode">
                    <el-button type="danger" slot="reference">删除</el-button>
                </el-popconfirm>
            </div>
        </el-dialog>
        <el-dialog
                :title="whichTitle"
                :visible.sync="showEditDialog"
                :close-on-click-modal="false"
        >
            <el-form :model="editForm" status-icon :rules="rules" ref="editForm" label-width="60px">
                <el-form-item label="头像" prop="photo">
                    <!--                    <el-input v-model="editForm.photo"></el-input>-->
                    <el-upload
                            class="avatar-uploader" :class="{tx:editForm.photo}"
                            action="https://jsonplaceholder.typicode.com/posts/"
                            :show-file-list="false"
                            :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload">
                        <template v-if="editForm.photo">
                            <img :src="editForm.photo" class="avatar">
                            <i class="el-icon-delete" @click.stop="handleRemove"></i>
                        </template>
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="姓名" prop="name">
                    <el-input v-model="editForm.name"></el-input>
                </el-form-item>
                <el-form-item label="性別" prop="gender">
                    <el-radio-group v-model="editForm.gender">
                        <el-radio label="male">男</el-radio>
                        <el-radio label="female">女</el-radio>
                    </el-radio-group>
                </el-form-item>
                <div style="display: flex;">
                    <el-col>
                        <el-form-item label="出生">
                            <el-date-picker type="date" placeholder="选择日期"
                                            v-model="editForm.birthDate" value-format="yyyy-MM-dd"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item label="死亡">
                            <el-date-picker type="date" placeholder="选择日期"
                                            v-model="editForm.deathDate" value-format="yyyy-MM-dd"></el-date-picker>
                        </el-form-item>
                    </el-col>
                </div>
                <el-form-item label="介绍">
                    <el-input type="textarea" v-model="editForm.details" rows="6"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('editForm')">提交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog
                title="颜色设置"
                :visible.sync="showSetDialog"
                :close-on-click-modal="false"
        >
            <el-form :model="colorForm" ref="colorForm">
                <el-row style="padding-bottom: 15px;">
                    <el-col :span="12">
                        <el-statistic
                                title="清新风格"
                        >
                            <template slot="formatter">
                                <div class="colorK qx" :class="{on:theme===1}" @click="setTheme(1)">
                                    <div>男性</div>
                                    <div>女性</div>
                                    <div>线条</div>
                                    <div>背景</div>
                                    <div>死亡</div>
                                </div>
                            </template>
                        </el-statistic>
                    </el-col>
                    <el-col :span="12">
                        <el-statistic
                                title="传统风格"
                        >
                            <template slot="formatter">
                                <div class="colorK ct" :class="{on:theme===2}" @click="setTheme(2)">
                                    <div>男性</div>
                                    <div>女性</div>
                                    <div>线条</div>
                                    <div>背景</div>
                                    <div>死亡</div>
                                </div>
                            </template>
                        </el-statistic>
                    </el-col>
                    <el-col :span="12">
                        <el-statistic
                                title="古典风格"
                        >
                            <template slot="formatter">
                                <div class="colorK gd" :class="{on:theme===3}" @click="setTheme(3)">
                                    <div>男性</div>
                                    <div>女性</div>
                                    <div>线条</div>
                                    <div>背景</div>
                                    <div>死亡</div>
                                </div>
                            </template>
                        </el-statistic>
                    </el-col>
                </el-row>
                <el-divider></el-divider>
                <el-row style="padding-bottom: 15px;">
                    <el-col :span="1"><i style="width: 1px;display: flex;opacity: 0;">?</i></el-col>
                    <el-col :span="4">
                        <el-statistic
                                title="男性颜色"
                        >
                            <template slot="formatter">
                                <el-tooltip class="item" effect="dark" content="边框颜色" placement="left-start">
                                    <el-color-picker v-model="colorForm.mline"></el-color-picker>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="背景颜色" placement="left-start">
                                    <el-color-picker v-model="colorForm.mbg"></el-color-picker>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="头像颜色" placement="left-start">
                                    <el-color-picker v-model="colorForm.mtx"></el-color-picker>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="字体颜色" placement="left-start">
                                    <el-color-picker v-model="colorForm.mwz"></el-color-picker>
                                </el-tooltip>
                            </template>
                        </el-statistic>
                    </el-col>
                    <el-col :span="4">
                        <el-statistic
                                title="女性颜色"
                        >
                            <template slot="formatter">
                                <el-tooltip class="item" effect="dark" content="边框颜色" placement="left-start">
                                    <el-color-picker v-model="colorForm.fline"></el-color-picker>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="背景颜色" placement="left-start">
                                    <el-color-picker v-model="colorForm.fbg"></el-color-picker>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="头像颜色" placement="left-start">
                                    <el-color-picker v-model="colorForm.ftx"></el-color-picker>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="字体颜色" placement="left-start">
                                    <el-color-picker v-model="colorForm.fwz"></el-color-picker>
                                </el-tooltip>
                            </template>
                        </el-statistic>
                    </el-col>
                    <el-col :span="4">
                        <el-statistic
                                title="死亡颜色"
                        >
                            <template slot="formatter">
                                <el-color-picker v-model="colorForm.deathline"></el-color-picker>
                                <el-color-picker v-model="colorForm.deathbg"></el-color-picker>
                            </template>
                        </el-statistic>
                    </el-col>
                    <el-col :span="4">
                        <el-statistic
                                title="背景颜色"
                        >
                            <template slot="formatter">
                                <el-color-picker v-model="colorForm.bg"></el-color-picker>
                            </template>
                        </el-statistic>
                    </el-col>
                    <el-col :span="4">
                        <el-statistic
                                title="线条颜色"
                        >
                            <template slot="formatter">
                                <el-color-picker v-model="colorForm.line"></el-color-picker>
                            </template>
                        </el-statistic>
                    </el-col>
                </el-row>
                <el-divider></el-divider>
                <el-form-item
                        style="display: flex;justify-content: center;margin-bottom: 0;">
                    <el-button type="primary" @click="submitForm1('colorForm')">确认</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <div class="tools">
            <div @click="saveImg" class="to to1">
                <i class="el-icon-camera-solid"></i>
            </div>
            <div @click="showSetDialog=true" class="to to2">
                <i class="el-icon-s-tools"></i>
            </div>
            <router-link :to="'/count/'+routeId" class="to to1">
                <i class="el-icon-pie-chart"></i>
            </router-link>
            <router-link to="/" class="to to3">
                <i class="el-icon-s-home"></i>
            </router-link>
        </div>
        <div id="color"></div>
    </div>
</template>

<script>
    import html2canvas from 'html2canvas';
    import FamilyNode from '../components/FamilyNode.vue'
    import * as d3 from "d3";

    export default {
        name: 'Home',
        components: {
            FamilyNode
        },
        data() {
            let validateName = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入姓名'));
                } else {
                    callback();
                }
            };
            return {
                familyTree: null,
                familyName: '',
                colors: null,
                nodes: [],//3d视图
                links: [],//3d视图
                view: '2d',
                direction: 'horizontal',
                type: 'round',
                showEditDialog: false,
                showSetDialog: false,
                showToolMenu: false,
                editMode: 'add', // 'add' 或 'edit'
                editForm: {
                    photo: '',
                    name: '',
                    gender: 'male',
                    birthDate: '',
                    deathDate: '',
                    details: ''
                },
                colorForm: {
                    bg: '',
                    fbg: '',
                    mbg: '',
                    deathbg: '',
                    line: '',
                    fline: '',
                    mline: '',
                    deathline: '',
                    ftx: '',
                    mtx: '',
                    fwz: '',
                    mwz: '',
                },
                rules: {
                    name: [
                        {required: true, validator: validateName, trigger: 'blur'}
                    ],
                },
                currentNode: null,
                whichLevel: '',//是哪个级别添加数据，自己me,兄弟姐妹siblings，父辈parent，儿女children，配偶spouse
                editWhich: false,//这个用来标注编辑的是否配偶
                captureWidth: 1920,
                captureHeight: 1080,
                isPress: false,
                theme: 0,
                routeId: this.$route.params.id,
                scrollX: 0,//拖动移动的距离
                scrollY: 0,//拖动移动的距离
                saveX: 0,//拖动后保存位置,很重要必须
                saveY: 0,//拖动后保存位置,很重要必须
            }
        },
        mounted() {
            window.addEventListener('resize', () => {
                if (this.showToolMenu) {
                    document.querySelectorAll('.po').forEach((el) => {
                        el.style.cssText = 'font-size:' + (el.scrollWidth - 30) + 'px'
                    })
                    document.querySelector('.my').style.cssText = 'font-size:' + (document.querySelector('.my').scrollWidth - 30) + 'px'
                }
            })
            //
            let hammertime = new Hammer(document.querySelector('.tree-container'));
            hammertime.get('pan').set({direction: Hammer.DIRECTION_ALL});
            hammertime.on('panstart', (ev) => {
                this.isPress = true
            });
            hammertime.on('panmove', (ev) => {
                this.scrollX = this.saveX + ev.deltaX
                this.scrollY = this.saveY + ev.deltaY
            });
            hammertime.on('panend', () => {
                this.saveX = this.scrollX
                this.saveY = this.scrollY
                this.isPress = false
            });

            // 3d视图
            if (this.view == '3d') {
                window.addEventListener('resize', () => {
                    this.drawGraph()
                })
            }


        },
        watch: {
            $route: {
                handler(route) {
                    let views = ['2d', '3d']
                    if (views.indexOf(route.query.view) > -1) {
                        this.view = route.query.view
                    } else {
                        this.view = '2d'
                    }
                    this.routeId = route.params.id
                    if (this.$store.state.family.family === null) {
                        this.$store.dispatch('family/getAll').then((rs) => {
                            let fi = rs.filter((el) => {
                                return el.id == this.routeId
                            })
                            if (fi.length > 0) {
                                this.familyTree = fi[0].tree
                                this.familyName = fi[0].name
                                this.direction = fi[0].direction
                                this.type = fi[0].type
                                this.colors = fi[0].colors
                                this.loadColors()
                            } else {
                                this.$message({
                                    message: '找不到族谱',
                                    type: 'error',
                                    onClose: () => {
                                        this.$router.push({path: '/'})
                                    }
                                });
                            }

                        })
                    } else {
                        let fi = this.$store.state.family.family.filter((el) => {
                            return el.id == this.routeId
                        })
                        if (fi.length > 0) {
                            this.familyTree = fi[0].tree
                            this.familyName = fi[0].name
                            this.direction = fi[0].direction
                            this.type = fi[0].type
                            this.colors = fi[0].colors
                            this.loadColors()
                        } else {
                            this.$message({
                                message: '找不到族谱',
                                type: 'error',
                                onClose: () => {
                                    this.$router.push({path: '/'})
                                }
                            });
                        }

                    }

                },
                immediate: true
            },

            showToolMenu: {
                immediate: true,
                handler(value) {
                    if (value) {
                        this.$nextTick(() => {
                            document.querySelectorAll('.po').forEach((el) => {
                                el.style.cssText = 'font-size:' + (el.scrollWidth - 30) + 'px'
                            })
                            document.querySelector('.my').style.cssText = 'font-size:' + (document.querySelector('.my').scrollWidth - 30) + 'px'
                        })
                    }

                }
            },
            familyTree: {
                immediate: true,
                deep: true,
                handler(value) {
                    if (value) {
                        if (this.view == '2d') {
                            this.$nextTick(() => {
                                //找那个family-node节点最宽值，最高值,为了截屏宽高做准备
                                let all = document.querySelectorAll('.family-node')
                                let wArray = [], hArray = []
                                all.forEach((el) => {
                                    // let style = el.getAttribute('style')
                                    // let array = style.split(';')
                                    // let w = array[0].split(':')[1].split('px')[0]
                                    // let h = array[1].split(':')[1].split('px')[0]
                                    wArray.push(el.getBoundingClientRect().width)
                                    hArray.push(el.getBoundingClientRect().height)
                                })
                                this.captureWidth = Math.max(...wArray)
                                this.captureHeight = Math.max(...hArray)
                            })

                        } else {

                            //转换3D视图需要的格式数据
                            let arrayNodes = [], arrayLinks = []
                            const {id, name, photo, gender, parent, details, birthDate, deathDate} = value;
                            arrayNodes.push({id, name, photo, gender, parent, details, birthDate, deathDate});

                            value.spouse.forEach((sp) => {
                                const {id, spid, name, photo, gender, details, birthDate, deathDate} = sp; // 解构并保留其他属性
                                arrayNodes.push({id, spid, name, photo, gender, details, birthDate, deathDate});
                            })

                            let fi1 = this.treeToFlat(value.children, [])
                            arrayNodes.push(...fi1)
                            this.nodes = arrayNodes
                            arrayNodes.forEach((el) => {
                                let fi = arrayNodes.filter((ell) => {
                                    return ell.parent == el.id
                                })
                                if (fi.length > 0) {
                                    fi.forEach((ef) => {
                                        arrayLinks.push({
                                            source: ef.id,
                                            target: el.id,
                                            type: el.gender == 'male' ? '父亲' : '母亲'
                                        })
                                    })
                                }

                                let fi2 = arrayNodes.filter((ell) => {
                                    return ell.spid == el.id
                                })

                                if (fi2.length > 0) {
                                    fi2.forEach((ef) => {
                                        arrayLinks.push({
                                            source: ef.id,
                                            target: el.id,
                                            type: ef.gender == 'male' ? '妻子' : '丈夫'
                                        })
                                    })
                                }

                                this.links = arrayLinks

                            })

                            this.$nextTick(() => {
                                this.drawGraph()
                            })


                        }


                    }

                }
            },

        },
        computed: {
            widthStyle() {
                return 'transform:translate(' + this.scrollX + 'px,' + this.scrollY + 'px);'
            },
            firstPo() {
                let node = this.findNodeById(this.familyTree, this.currentNode.parent)
                if (node.children.length > 0) {
                    let index = node.children.indexOf(this.currentNode)
                    if (index > 0) {
                        return false
                    } else {
                        return true
                    }
                }


            },
            lastPo() {
                let node = this.findNodeById(this.familyTree, this.currentNode.parent)
                if (node.children.length > 0) {
                    let index = node.children.indexOf(this.currentNode)
                    if (index < node.children.length - 1) {
                        return false
                    } else {
                        return true
                    }
                }

            },
            whichTitle() {
                if (this.currentNode) {
                    if (this.whichLevel === 'me') {
                        return '修改' + this.currentNode.name + '信息'
                    } else if (this.whichLevel === 'spouse') {
                        return '向' + this.currentNode.name + '添加配偶信息'
                    } else if (this.whichLevel === 'children') {
                        return '向' + this.currentNode.name + '添加子辈信息'
                    } else if (this.whichLevel === 'siblings') {
                        return '向' + this.currentNode.name + '添加兄妹信息'
                    } else if (this.whichLevel === 'parent') {
                        return '向' + this.currentNode.name + '添加父辈信息'
                    }

                } else {
                    return '添加人员信息'
                }
            }
        },
        methods: {
            drawGraph() {
                const container = this.$refs.graphContainer
                d3.select(container).selectAll('*').remove()

                const width = window.innerWidth
                const height = window.innerHeight

                const svg = d3.select(container)
                    .append('svg')
                    .attr('width', width)
                    .attr('height', height)

                const simulation = d3.forceSimulation(this.nodes)
                    .force('link', d3.forceLink(this.links).id(d => d.id).distance(window.innerWidth > 768 ? 90 : 50))
                    .force('charge', d3.forceManyBody().strength(-width / 5))
                    .force("x", d3.forceX(width / 2))
                    .force("y", d3.forceY(height / 2))

                // 添加渐变
                const linear = svg.append('defs').append('linearGradient')
                    .attr('id', 'linearGradient')
                    .attr('x1', '0%')
                    .attr('y1', '0%')
                    .attr('x2', '100%')
                    .attr('y2', '100%')

                linear.append('stop')
                    .attr('offset', '0%')
                    .style('stop-color', '#F7C7DF')

                linear.append('stop')
                    .attr('offset', '100%')
                    .style('stop-color', '#fff')


                // 添加箭头标记定义
                svg.append('defs').append('marker')
                    .attr('id', 'arrowhead')
                    .attr('viewBox', '0 -5 10 10')
                    .attr('refX', window.innerWidth > 768 ? 35 : '9vw')
                    .attr('refY', 0)
                    .attr('orient', 'auto')
                    .attr('markerWidth', window.innerWidth > 768 ? 10 : '2vw')
                    .attr('markerHeight', window.innerWidth > 768 ? 10 : '2vw')
                    .append('path')
                    .attr('d', 'M0,-5L10,0L0,5')
                    .attr('fill', '#666')

                const link = svg.append('g')
                    .selectAll('line')
                    .data(this.links)
                    .enter()
                    .append('line')
                    .attr('stroke', '#999')
                    .attr('stroke-opacity', 0.6)
                    .attr('marker-end', 'url(#arrowhead)')

                const linkText = svg.append('g')
                    .selectAll('text')
                    .data(this.links)
                    .enter()
                    .append('text')
                    .text(d => d.type)
                    .attr('font-size', window.innerWidth > 768 ? 10 : '2vw')
                    .attr('fill', '#999')
                    .attr("text-anchor", "middle")
                    .attr("paint-order", "stroke")
                    .attr('stroke', 'var(--bg)')
                    .attr("stroke-width", 6)




                const node = svg.append('g')
                    .selectAll('g')
                    .data(this.nodes)
                    .enter()
                    .append('g')
                    .call(d3.drag()
                        .on('start', (event, d) => {
                            if (!event.active) simulation.alphaTarget(0.3).restart()
                            d.fx = d.x
                            d.fy = d.y
                        })
                        .on('drag', (event, d) => {
                            d.fx = event.x
                            d.fy = event.y
                        })
                        .on('end', (event, d) => {
                            if (!event.active) simulation.alphaTarget(0)
                            d.fx = null
                            d.fy = null
                        })
                    ).on("click", (event, d) => {

                    });

                const color = d3.scaleOrdinal()
                    .domain(this.nodes.filter(d => d.id))
                    .range(d3.quantize(t => d3.interpolateSpectral(t * 0.7 + 0.1), this.nodes.length).reverse());

                node.append('circle')
                    .attr('r', window.innerWidth > 768 ? 25 : '5vw')
                    //.attr('r', 'clamp(2vw,3.2vw,25px)')
                    //.attr('fill', d => color(d.id))
                    //.attr('fill', d => d.gender=='female'?'url(#linearGradient)':color(d.id))
                    .attr('fill', d => d.deathDate ? 'var(--deathbg)' : color(d.id))
                    .attr('stroke', d => d.deathDate ? 'var(--deathline)' :d.gender=='female'?'var(--fline)':'var(--mline)' )
                    //.attr('stroke', d => d.gender=='female'?'url(#linearGradient)':color(d.id))

                node.append('text')
                    .text(d => d.name)
                    .attr('text-anchor', 'middle')
                    .attr('y', 4)
                    .attr('fill', d => d.deathDate ? 'var(--deathline)' : '#000')
                    .attr('font-size', window.innerWidth > 768 ? 12 : '2.4vw')

                simulation.on('tick', () => {
                    link
                        .attr('x1', d => d.source.x)
                        .attr('y1', d => d.source.y)
                        .attr('x2', d => d.target.x)
                        .attr('y2', d => d.target.y)

                    linkText
                        .attr('x', d => (d.source.x + d.target.x) / 2)
                        .attr('y', d => (d.source.y + d.target.y) / 2)


                    node
                        .attr('transform', d => `translate(${d.x},${d.y})`)
                })
            },
            treeToFlat(tree, result = []) {
                tree.forEach(node => {
                    const {id, name, photo, gender, parent, spouse, details, children, birthDate, deathDate} = node; // 解构并保留其他属性
                    result.push({id, name, photo, gender, parent, details, birthDate, deathDate});
                    spouse.forEach((sp) => {
                        const {id, spid, name, photo, gender, details, birthDate, deathDate} = sp; // 解构并保留其他属性
                        result.push({id, spid, name, photo, gender, details, birthDate, deathDate});
                    })
                    if (children && children.length > 0) {
                        this.treeToFlat(children, result);
                    }
                });
                return result;
            },
            async handleRemove() {
                this.editForm.photo = ''
                let arr = this.currentNode.photo.split('/')
                let len = arr.length
                await this.$supabase
                    .storage
                    .from('my')
                    .remove(arr[len - 1])
                this.$message.success('头像删除成功！');
                // if (error==null) {
                //     this.$message.success('头像删除成功！');
                // } else {
                //     this.$message.error(error);
                // }


            },
            async handleAvatarSuccess(res, file) {
                //this.editForm.photo = URL.createObjectURL(file.raw);
                const {error} = await this.$supabase
                    .storage
                    .from('my')
                    .upload(file.name, file.raw)
                if (error) {
                    this.$message.error(error);
                } else {
                    this.$message.success('头像上传成功！');
                    const {data} = await this.$supabase
                        .storage
                        .from('my')
                        .getPublicUrl(file.name)
                    this.editForm.photo = data.publicUrl
                }

            },
            beforeAvatarUpload(file) {
                let types = ['image/jpeg', 'image/png', 'image/gif']
                const isJPG = types.indexOf(file.type) > -1;
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isJPG) {
                    this.$message.error('上传头像只能是jpg,png,gif图片格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过2MB!');
                }
                return isJPG && isLt2M;
            },
            saveImg() {
                let x = this.scrollX
                let y = this.scrollY
                if (this.captureWidth > window.innerWidth) {
                    x += (window.innerWidth - this.captureWidth) * 0.5
                } else {
                    x += (window.innerWidth - this.captureWidth) * 0.5
                }

                html2canvas(document.querySelector('.tree-container'), {
                    useCORS: true,
                    width: this.captureWidth + 120,
                    height: this.captureHeight + 120,
                    x: x - 60,
                    y: y - 60,
                    backgroundColor: window.getComputedStyle(document.body).backgroundColor
                }).then((canvas) => {
                    let lastpic
                    canvas.toBlob((blob) => {
                        lastpic = URL.createObjectURL(blob)
                        let eleLink = document.createElement('a');
                        eleLink.download = this.familyName + '族谱';
                        eleLink.style.display = 'none';
                        eleLink.href = lastpic;
                        eleLink.click();
                    }, 'image/png', 1);
                });
            },
            toolMenu(node) {
                this.editWhich = false
                this.currentNode = node
                this.showToolMenu = true
            },
            toolMenuS(node) {
                this.editWhich = true
                this.currentNode = node
                this.showToolMenu = true
            },
            findNodeById(tree, id) {
                if (tree.id === id) {
                    return tree; // 找到匹配的节点，返回它
                } else if (tree.children) { // 检查是否有子节点
                    for (let child of tree.children) {
                        const result = this.findNodeById(child, id); // 递归搜索子节点
                        if (result) {
                            return result; // 如果在子节点中找到，返回该节点
                        }
                    }
                }
                return null; // 没有找到匹配的节点
            },
            moveLeft() {
                let node = this.findNodeById(this.familyTree, this.currentNode.parent)
                let index = node.children.indexOf(this.currentNode)
                node.children.splice(index - 1, 0, node.children.splice(index, 1)[0]);
                this.saveTree()
                this.showToolMenu = false
            },
            moveRight() {
                let node = this.findNodeById(this.familyTree, this.currentNode.parent)
                let index = node.children.indexOf(this.currentNode)
                node.children.splice(index + 1, 0, node.children.splice(index, 1)[0]);
                this.saveTree()
                this.showToolMenu = false

            },
            addNode(text) {
                this.editMode = 'add'
                this.showEditDialog = true
                this.whichLevel = text
                let xb = 'male'
                if (text === 'spouse') {
                    xb = this.currentNode.gender === 'male' ? 'female' : 'male'
                }
                this.editForm = {
                    photo: '',
                    name: '',
                    gender: xb,
                    birthDate: '',
                    deathDate: '',
                    details: '',
                }
            },
            deleteNode() {
                let node = this.currentNode
                if (this.editWhich === false) {
                    if (node.parent) {
                        let fi = this.findNodeById(this.familyTree, node.parent)
                        const index = fi.children.indexOf(node)
                        if (index > -1) {
                            fi.children.splice(index, 1)
                        }
                    } else {
                        this.familyTree = null
                        this.currentNode = null
                    }
                } else {
                    let fi = this.findNodeById(this.familyTree, node.spid)
                    const index = fi.spouse.indexOf(node)
                    if (index > -1) {
                        fi.spouse.splice(index, 1)
                    }


                }
                this.$message({
                    message: '删除成功',
                    type: 'success'
                });
                this.showToolMenu = false
                this.saveTree()
            },
            editNode(text) {
                this.showEditDialog = true
                this.editMode = 'edit'
                this.whichLevel = text
                this.editForm = {
                    photo: this.currentNode.photo,
                    name: this.currentNode.name,
                    gender: this.currentNode.gender,
                    birthDate: this.currentNode.birthDate,
                    deathDate: this.currentNode.deathDate,
                    details: this.currentNode.details,
                }
            },
            async saveTree() {
                await this.$supabase.from('familytree').update({'tree': this.familyTree}).eq('id', this.routeId)
                await this.$store.dispatch('family/getAll')
                //location.reload()
                //this.$router.go(0); // 重新加载当前路由
            },
            loadColors() {
                this.colorForm = this.colors
                this.$nextTick(() => {
                    this.setColor()
                })


            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$message({
                            message: '添加成功',
                            type: 'success'
                        });
                        this.saveEdit()

                    } else {
                        return false;
                    }
                });
            },
            submitForm1(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$message({
                            message: '设置成功',
                            type: 'success'
                        });
                        this.showSetDialog = false
                        this.saveColors()
                    } else {
                        return false;
                    }
                });
            },
            saveEdit() {
                if (this.editMode === 'add') {
                    const newNode = {
                        id: Date.now(),
                        photo: this.editForm.photo,
                        name: this.editForm.name,
                        gender: this.editForm.gender,
                        birthDate: this.editForm.birthDate,
                        deathDate: this.editForm.deathDate,
                        details: this.editForm.details,
                        children: [],
                        parent: '',
                        spouse: []
                    }
                    const newNodeSP = {
                        id: Date.now(),
                        photo: this.editForm.photo,
                        name: this.editForm.name,
                        gender: this.editForm.gender,
                        birthDate: this.editForm.birthDate,
                        deathDate: this.editForm.deathDate,
                        details: this.editForm.details,
                    }
                    if (this.currentNode) {
                        if (this.whichLevel === 'children') {
                            let node
                            if (this.currentNode.spid) {
                                node = this.findNodeById(this.familyTree, this.currentNode.spid)

                            } else {
                                node = this.currentNode
                                newNode.parent = this.currentNode.id
                            }
                            node.children.push(newNode)
                            newNode.parent = node.id


                        } else if (this.whichLevel === 'spouse') {
                            this.currentNode.spouse.push(newNodeSP)
                            newNodeSP.spid = this.currentNode.id

                        } else if (this.whichLevel === 'siblings') {
                            let node = this.findNodeById(this.familyTree, this.currentNode.parent)
                            if (node) {
                                node.children.push(newNode)
                                newNode.parent = node.id
                            }

                        } else if (this.whichLevel === 'parent') {
                            let node = this.currentNode
                            newNode.children.push(node)
                            node.parent = newNode.id
                            this.familyTree = newNode

                        }
                    } else {
                        this.familyTree = newNode
                    }
                } else if (this.editMode === 'edit' && this.currentNode) {
                    this.currentNode.photo = this.editForm.photo
                    this.currentNode.name = this.editForm.name
                    this.currentNode.gender = this.editForm.gender
                    this.currentNode.birthDate = this.editForm.birthDate
                    this.currentNode.deathDate = this.editForm.deathDate
                    this.currentNode.details = this.editForm.details
                }
                this.saveTree()
                this.showEditDialog = false
                this.showToolMenu = false
            },
            async saveColors() {
                await this.$supabase.from('familytree').update({'colors': this.colorForm}).eq('id', this.routeId)
                await this.$store.dispatch('family/getAll')
                this.setColor()
            },
            setTheme(index) {
                this.theme = index
                if (index === 1) {
                    this.colorForm = {
                        bg: '#FAF9F5',
                        fbg: '#F7C7DF',
                        mbg: '#AFD1ED',
                        deathbg: '#fff',
                        line: '#666',
                        fline: '#DE6BA6',
                        mline: '#5f92bd',
                        deathline: '#aaa',
                        ftx: '#DE6BA6',
                        mtx: '#5f92bd',
                        fwz: '#000',
                        mwz: '#000',

                    }
                } else if (index === 2) {
                    this.colorForm = {
                        bg: '#F6F3EC',
                        fbg: '#ead9ad',
                        mbg: '#29c1c4',
                        deathbg: '#fff',
                        line: '#e3bc54',
                        fline: '#e3bc54',
                        mline: '#227b7e',
                        deathline: '#aaa',
                        ftx: '#e3bc54',
                        mtx: '#227b7e',
                        fwz: '#000',
                        mwz: '#000',
                    }
                } else if (index === 3) {
                    this.colorForm = {
                        bg: '#F6F3EC',
                        fbg: '#FFF2E7',
                        mbg: '#E0CCBB',
                        deathbg: '#fff',
                        line: '#997462',
                        fline: '#997462',
                        mline: '#693C26',
                        deathline: '#aaa',
                        ftx: '#997462',
                        mtx: '#693C26',
                        fwz: '#000',
                        mwz: '#000',
                    }
                }
                this.saveColors()
            },
            setColor() {
                let style = document.createElement('style');
                style.textContent = `:root{--bg:${this.colorForm.bg};--line: ${this.colorForm.line};
    --fline: ${this.colorForm.fline};
    --fbg: ${this.colorForm.fbg};
    --mline: ${this.colorForm.mline};
    --mbg: ${this.colorForm.mbg};
    --deathbg:${this.colorForm.deathbg};
    --deathline:${this.colorForm.deathline};
    --ftx:${this.colorForm.ftx};
    --mtx:${this.colorForm.mtx};
    --fwz:${this.colorForm.fwz};
    --mwz:${this.colorForm.mwz};

    }`
                if (document.querySelector('#color').innerHTML) {
                    document.querySelector('#color').innerHTML = ''

                }
                document.querySelector('#color').appendChild(style)


            }
        }
    }
</script>

